__turbopack_context__.v({
  "contactLink": "OfficeLocationSection-module-scss-module__cJpO2G__contactLink",
  "container": "OfficeLocationSection-module-scss-module__cJpO2G__container",
  "content": "OfficeLocationSection-module-scss-module__cJpO2G__content",
  "imageWrapper": "OfficeLocationSection-module-scss-module__cJpO2G__imageWrapper",
  "root": "OfficeLocationSection-module-scss-module__cJpO2G__root",
  "teamImage": "OfficeLocationSection-module-scss-module__cJpO2G__teamImage",
});
